var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-row",
        { attrs: { align: "center", "no-gutters": "" } },
        [
          _c("span", { staticClass: "mr-5" }, [
            _vm._v(_vm._s(_vm.attributeData.displayName)),
          ]),
          _c("v-switch", {
            attrs: {
              inset: "",
              dense: "",
              disabled: _vm.isLoading,
              "input-value": _vm.value,
              value: _vm.value,
              "error-messages": _vm.errorMessage,
            },
            on: {
              change: function ($event) {
                return _vm.$emit("input", $event === null ? false : $event)
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }